/* ==========================================================================
   Ryse - Theoric: a BARRINHA DE FRETE + a FOLHA DE OFERTA da barra fixa (celular)

   Romulo, 12/07/2026: "e se a barra fosse inteligente o suficiente pra recomendar
   produtos ou executar funcoes, abrindo suavemente?"
   Romulo, 13/07/2026: "e se a barrinha fosse de frete gratis? Ela precisa ser
   dinamica. Podemos criar regras."

   O visual esta em theoric-pdp-oferta.css + theoric-pdp-oferta-barrinha.css.
   Aqui vive a DECISAO: o que a barra tem a dizer, quando ela pode dizer, e - a
   parte que quase ninguem escreve - QUANDO ELA PRECISA CALAR A BOCA.

   ==========================================================================
   >>> "INTELIGENTE" AQUI NAO E IA. E UMA TABELA DE REGRAS. <<<
   Uma mensagem por vez. A PRIMEIRA que casar vence. Barra que fala tres coisas
   nao diz nenhuma.

     0. SEM ESTOQUE ........ silencio. Nao se vende o que nao existe.
     1. JA LIBEROU ......... "Frete gratis liberado" + barra cheia (verde).
                             A folha MUDA DE ASSUNTO: vira "combina com".
     2. FALTA POUCO ........ "Faltam R$ 43 para o frete gratis" + barra proporcional.
        (lacuna <= 40%)      A folha oferece quem FECHA A LACUNA, do mais barato ao
                             mais caro, com selo em quem resolve.
     3. FALTA MUITO ........ NAO fala de frete. Vira "combina com".
     4. CARRINHO VAZIO ..... silencio.

   >>> A REGRA 3 E A MAIS IMPORTANTE E A MENOS OBVIA. <<<
   Quando falta muito, a barra CALA sobre frete. Uma barra em 12% nao motiva -
   ela informa a pessoa de que ela esta longe, e isso REDUZ a chance de tentar.
   Barra de progresso so funciona perto do fim. E o mesmo motivo pelo qual cartao
   de fidelidade ja vem com dois selos carimbados.

   >>> E A REGRA 4 E A MAIS TENTADORA DE QUEBRAR. <<<
   Carrinho vazio = barra em 0%. Um zero nao e uma meta, e um anuncio de distancia.

   ==========================================================================
   >>> DINAMICA NO TEMPO: A BARRA ASSINA O CARRINHO. <<<
   TheoricCart.ao(iniciar) repinta a cada mudanca. A pessoa adiciona um item pela
   folha e VE a lacuna encolher, a barrinha encher e - quando fecha - o estado virar
   "liberado" na frente dela. Esse loop e o produto. Sem ele, isto e so um letreiro.

   Enquanto a folha esta ABERTA, o carrinho pode mudar - mas os cards NAO sao
   redesenhados. Redesenhar arrancaria da tela o card que a pessoa acabou de tocar
   (e o "Adicionado" voltaria a ser "Adicionar"). Muda o texto, a barra e os selos.
   O DOM fica parado. Nada pisca.

   ==========================================================================
   >>> AS TRAVAS DO AUTO-ABRIR (a parte que protege o cliente da gente) <<<
   NUNCA FECHE SOZINHO O QUE A PESSOA ABRIU. O relogio so existe para a abertura
   automatica - e PAUSA quando o dedo encosta. Quem esta lendo nao terminou.

   A abertura automatica so acontece se TODAS forem verdade:
     - o estado e FRETE (regra 2) - o unico momento em que interromper ajuda;
     - a pessoa chegou ao fim da descricao (esta decidindo, nao lendo);
     - a pagina nao esta rolando (abrir embaixo do dedo faz tocar errado);
     - ainda nao abriu nesta SESSAO (ela ve 5 produtos, nao pode levar 5 interrupcoes);
     - ela nao recusou antes.

   ==========================================================================
   >>> O NUMERO DO FRETE VEM DE UM LUGAR SO: snippets/brinde-config.liquid. <<<
   window.THEORIC_FRETE.limite. Nao ha numero chumbado aqui - e por isso a barrinha
   nao pode contradizer o carrinho. Se o selo da PDP ainda trouxer o valor antigo
   (chumbado em main-product.liquid, 138KB), corrigirSelo() reescreve o texto do selo.
   Curativo consciente: o certo e consertar na fonte quando esse arquivo for aberto.

   Carregado por snippets/theoric-fav-button.liquid (que so existe na PDP).
   ========================================================================== */
(function () {
  'use strict';

  var LARGURA_MAX = 749;      /* a barra fixa so existe abaixo disto */
  var FAIXA_DA_ALCA = 56;
  var PUXAO_QUE_FECHA = 80;
  var SEGUNDOS_AUTO = 6000;   /* so vale para o que abriu SOZINHO */
  var PERTO = 0.4;            /* lacuna <= 40% do limite = "falta pouco" (regra 2) */
  var CHAVE_VISTA = 'theoric-oferta-vista';
  var CHAVE_RECUSA = 'theoric-oferta-recusada';

  var barra = document.getElementById('theoricStickyBuy');
  if (!barra) return;

  var noCelular = function () { return window.innerWidth <= LARGURA_MAX; };

  /* ------------------------------------------------------------------ dados */
  function produtoId() {
    var produto = document.querySelector('.theoric-main-product[data-product-id]');
    return produto ? produto.getAttribute('data-product-id') : null;
  }

  /* UM lugar so. Ver o cabecalho. */
  function limiteFrete() {
    if (window.THEORIC_FRETE && window.THEORIC_FRETE.limite) return window.THEORIC_FRETE.limite;
    if (window.THEORIC_BRINDE_NOTIFY && window.THEORIC_BRINDE_NOTIFY.threshold) {
      return window.THEORIC_BRINDE_NOTIFY.threshold;
    }
    return 0;   /* sem numero confiavel, a barra cala. Melhor mudo que mentiroso. */
  }

  function temEstoque() {
    var real = document.querySelector('#main-product-form-container .product-form__submit');
    return !(real && real.disabled);
  }

  function moeda(centavos) {
    if (window.TheoricCart && TheoricCart.moeda) return TheoricCart.moeda(centavos);
    return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  /* O selo da PDP nao pode dizer um numero e a barrinha outro. Se main-product.liquid
     ainda chumba o valor antigo, o texto e corrigido aqui. Curativo, nao cura. */
  function corrigirSelo() {
    var limite = limiteFrete();
    if (!limite) return;

    var selo = document.querySelector('.theoric-pdp__shipping-threshold-tag');
    if (!selo) return;

    var bruto = selo.textContent.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    var reais = parseFloat(bruto);
    if (!isFinite(reais)) return;

    var noSelo = Math.round(reais * 100);
    if (noSelo === limite) return;   /* ja concordam: nao mexe */

    selo.textContent = selo.textContent.replace(/R\$\s?[\d.,]+/, moeda(limite));
  }

  /* --------------------------------------------------------------- o markup */
  var linha = document.createElement('button');
  linha.type = 'button';
  linha.className = 'theoric-oferta-linha';
  linha.setAttribute('aria-expanded', 'false');
  linha.hidden = true;

  var textoLinha = document.createElement('span');
  linha.appendChild(textoLinha);
  linha.insertAdjacentHTML(
    'beforeend',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>' +
    '<span class="theoric-oferta-linha__trilha"><span class="theoric-oferta-linha__enchimento" data-enchimento></span></span>'
  );
  var enchimento = linha.querySelector('[data-enchimento]');

  /* a barra vira coluna: a linha em cima, o preco + botao embaixo (intactos) */
  var fileira = document.createElement('div');
  fileira.className = 'theoric-sticky-buy__row';
  while (barra.firstChild) fileira.appendChild(barra.firstChild);
  barra.appendChild(linha);
  barra.appendChild(fileira);

  var folha = document.createElement('div');
  folha.className = 'theoric-oferta';
  folha.setAttribute('role', 'dialog');
  folha.setAttribute('aria-label', 'Sugestões');
  folha.innerHTML =
    '<div class="theoric-oferta__cabecalho">' +
    '  <p class="theoric-oferta__titulo" data-oferta-titulo></p>' +
    '  <p class="theoric-oferta__sub" data-oferta-sub></p>' +
    '</div>' +
    '<div class="theoric-oferta__lista" data-oferta-lista></div>';
  document.body.appendChild(folha);

  var elTitulo = folha.querySelector('[data-oferta-titulo]');
  var elSub = folha.querySelector('[data-oferta-sub]');
  var elLista = folha.querySelector('[data-oferta-lista]');

  /* a folha para EXATAMENTE em cima da barra - o botao Comprar nunca some.
     A barra muda de altura quando a linha nasce, entao isto e remedido. */
  function medirBarra() {
    document.documentElement.style.setProperty(
      '--tso-fundo',
      Math.round(barra.getBoundingClientRect().height) + 'px'
    );
  }

  /* ===================================================================
     A TABELA DE REGRAS. Primeira que casar vence. Ver o cabecalho.
     =================================================================== */
  var estado = { tipo: null, falta: 0, progresso: 0 };

  function decidir(carrinho) {
    var limite = limiteFrete();
    var total = carrinho ? carrinho.total_price : 0;
    var itens = carrinho ? carrinho.item_count : 0;

    estado.falta = 0;
    estado.progresso = 0;

    /* 0. sem estoque: silencio */
    if (!temEstoque()) { estado.tipo = null; return; }

    /* 4. carrinho vazio: silencio (um zero nao e meta, e distancia) */
    if (!itens || !limite) { estado.tipo = null; return; }

    /* 1. ja liberou */
    if (total >= limite) {
      estado.tipo = 'liberado';
      estado.progresso = 1;
      return;
    }

    var falta = limite - total;

    /* 2. falta pouco: a meta vale ser dita */
    if (falta <= limite * PERTO) {
      estado.tipo = 'frete';
      estado.falta = falta;
      estado.progresso = total / limite;
      return;
    }

    /* 3. falta muito: nao fala de frete */
    estado.tipo = 'combina';
  }

  function pintarLinha() {
    if (!noCelular() || !estado.tipo) {
      linha.hidden = true;
      medirBarra();
      return;
    }

    linha.classList.toggle('tem-barra', estado.tipo === 'frete' || estado.tipo === 'liberado');
    linha.classList.toggle('esta-liberada', estado.tipo === 'liberado');

    if (estado.tipo === 'frete') {
      textoLinha.innerHTML =
        'Faltam <strong>' + moeda(estado.falta) + '</strong> para o frete grátis';
    } else if (estado.tipo === 'liberado') {
      textoLinha.textContent = 'Frete grátis liberado';
    } else {
      textoLinha.textContent = 'Combina com este produto';
    }

    enchimento.style.width = Math.round(estado.progresso * 100) + '%';

    linha.hidden = false;
    medirBarra();
  }

  function pintarFolha() {
    if (estado.tipo === 'frete') {
      elTitulo.textContent = 'Complete o frete grátis';
      elSub.textContent =
        'Faltam ' + moeda(estado.falta) + '. Estes fecham o valor.';
    } else if (estado.tipo === 'liberado') {
      elTitulo.textContent = 'Frete grátis liberado';
      elSub.textContent = 'Já que o frete está por nossa conta, estes combinam com o que você leva.';
    } else {
      elTitulo.textContent = 'Combina com este produto';
      elSub.textContent = 'Selecionados a partir do que outras pessoas levaram junto.';
    }

    atualizarSelos();
  }

  /* ------------------------------------------------- as recomendacoes */
  var recomendados = null;
  var buscando = null;

  function buscarRecs() {
    if (recomendados) return Promise.resolve(recomendados);
    if (buscando) return buscando;

    var id = produtoId();
    if (!id) return Promise.resolve([]);

    buscando = fetch('/recommendations/products.json?product_id=' + id + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        recomendados = (d.products || []).filter(function (p) {
          return p.available && p.variants && p.variants.length;
        });
        return recomendados;
      })
      .catch(function () { return []; })
      .finally(function () { buscando = null; });

    return buscando;
  }

  /* >>> QUANDO HA META, A ORDEM DOS CARDS E A OFERTA. <<<
     Primeiro quem FECHA a lacuna, do mais barato ao mais caro (o menor esforco para
     bater a meta vem na frente). Depois o resto, do mais caro ao mais barato (quem
     chega mais perto). Recomendar por relevancia aqui seria desperdicar o unico
     momento em que a pessoa tem um motivo aritmetico para adicionar algo. */
  function ordenarParaMeta(lista, falta) {
    var fecham = lista.filter(function (p) { return p.price >= falta; })
                      .sort(function (a, b) { return a.price - b.price; });
    var resto = lista.filter(function (p) { return p.price < falta; })
                     .sort(function (a, b) { return b.price - a.price; });
    return fecham.concat(resto);
  }

  /* o esqueleto existe para a animacao nao correr atras da foto: se os cards chegam
     depois, a folha cresce no meio da propria abertura. O LUGAR deles nasce junto. */
  function esqueleto() {
    elLista.innerHTML = '';
    for (var i = 0; i < 3; i++) {
      var c = document.createElement('div');
      c.className = 'theoric-oferta__card esta-vazio';
      c.innerHTML =
        '<div class="theoric-oferta__foto"></div>' +
        '<p class="theoric-oferta__nome"></p>' +
        '<p class="theoric-oferta__preco"></p>';
      elLista.appendChild(c);
    }
  }

  function desenharCards(lista) {
    var ordenada = estado.tipo === 'frete' ? ordenarParaMeta(lista, estado.falta) : lista;

    elLista.innerHTML = '';

    ordenada.slice(0, 6).forEach(function (p) {
      var v = p.variants[0];

      var card = document.createElement('div');
      card.className = 'theoric-oferta__card';
      card.setAttribute('data-preco', p.price);   /* para o selo ser reavaliado depois */

      var foto = p.featured_image || (p.images && p.images[0]) || '';
      card.innerHTML =
        '<a class="theoric-oferta__foto" href="' + p.url + '">' +
        (foto ? '<img src="' + foto + '&width=300" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a class="theoric-oferta__nome" href="' + p.url + '">' + ((window.theoricNomes && window.theoricNomes[p.handle]) || p.title) + '</a>' +
        '<p class="theoric-oferta__preco">' + moeda(p.price) + '</p>' +
        '<span class="theoric-oferta__selo">Fecha o frete</span>';

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'theoric-oferta__add';
      add.textContent = 'Adicionar';
      add.addEventListener('click', function () { adicionar(v.id, add); });

      card.appendChild(add);
      elLista.appendChild(card);
    });

    atualizarSelos();
  }

  /* O carrinho muda com a folha aberta -> o selo muda, o DOM nao. Ver o cabecalho:
     redesenhar arrancaria da tela o card que a pessoa acabou de tocar. */
  function atualizarSelos() {
    var cards = elLista.querySelectorAll('.theoric-oferta__card[data-preco]');

    Array.prototype.forEach.call(cards, function (card) {
      var preco = parseInt(card.getAttribute('data-preco'), 10);
      var fecha = estado.tipo === 'frete' && isFinite(preco) && preco >= estado.falta;
      card.classList.toggle('fecha-a-meta', fecha);
    });
  }

  /* ------------------------------------------------------- adicionar */
  function adicionar(variante, botao) {
    botao.disabled = true;
    botao.textContent = 'Adicionando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variante, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        botao.textContent = 'Adicionado';

        /* nao chamo /cart.js: quem cuida do estado do carrinho e o nucleo.
           O TheoricCart.ao() repinta a linha, a barrinha e os selos sozinho. */
        if (window.TheoricCart) {
          TheoricCart.sincronizar(true);
          TheoricCart.atualizarBolinha();
        }
      })
      .catch(function () {
        botao.disabled = false;
        botao.textContent = 'Tentar de novo';
      });
  }

  /* ---------------------------------------------------- abrir / fechar */
  var relogio = null;
  var abertaPorToque = false;

  function abrir(porToque) {
    if (!noCelular()) return;
    if (!estado.tipo) return;
    if (folha.classList.contains('esta-aberta')) return;

    abertaPorToque = !!porToque;

    pintarFolha();
    esqueleto();
    medirBarra();

    folha.classList.add('esta-aberta');
    linha.setAttribute('aria-expanded', 'true');

    buscarRecs().then(function (lista) {
      if (lista.length) desenharCards(lista);
      else fechar();   /* sem produto pra mostrar, nao ha folha a mostrar */
    });

    if (!abertaPorToque) armarRelogio();
  }

  function fechar(porRecusa) {
    if (!folha.classList.contains('esta-aberta')) return;

    desarmarRelogio();
    folha.classList.remove('esta-aberta');
    folha.style.transform = '';
    linha.setAttribute('aria-expanded', 'false');

    if (porRecusa && !abertaPorToque) {
      try { sessionStorage.setItem(CHAVE_RECUSA, '1'); } catch (e) {}
    }
  }

  function armarRelogio() {
    desarmarRelogio();
    relogio = setTimeout(function () { fechar(false); }, SEGUNDOS_AUTO);
  }

  function desarmarRelogio() {
    clearTimeout(relogio);
    relogio = null;
  }

  /* o dedo encostou: quem esta lendo nao terminou. O relogio para. */
  folha.addEventListener('pointerdown', desarmarRelogio);
  folha.addEventListener('pointerenter', desarmarRelogio);

  linha.addEventListener('click', function () {
    if (folha.classList.contains('esta-aberta')) fechar(true);
    else abrir(true);
  });

  /* tocar fora fecha - mas a BARRA nao e "fora": ela e a dona da folha. */
  document.addEventListener('click', function (e) {
    if (!folha.classList.contains('esta-aberta')) return;
    if (folha.contains(e.target) || barra.contains(e.target)) return;
    fechar(true);
  });

  /* ------------------------------------------------------- o arraste */
  var arrastando = false;
  var yInicial = 0;
  var dy = 0;

  folha.addEventListener('pointerdown', function (e) {
    if (!noCelular()) return;

    var r = folha.getBoundingClientRect();
    if (e.clientY - r.top > FAIXA_DA_ALCA) return;   /* dedo na lista, nao na alca */

    arrastando = true;
    yInicial = e.clientY;
    dy = 0;
    folha.classList.add('esta-arrastando');
    try { folha.setPointerCapture(e.pointerId); } catch (erro) {}
  });

  folha.addEventListener('pointermove', function (e) {
    if (!arrastando) return;
    dy = e.clientY - yInicial;
    folha.style.transform = 'translateY(' + (dy > 0 ? dy : dy / 4) + 'px)';
  });

  function largar() {
    if (!arrastando) return;
    arrastando = false;
    folha.classList.remove('esta-arrastando');

    if (dy > PUXAO_QUE_FECHA) fechar(true);
    else folha.style.transform = '';
  }

  folha.addEventListener('pointerup', largar);
  folha.addEventListener('pointercancel', largar);

  /* ------------------------------------------- o gatilho do auto-abrir */
  var paginaRolando = false;
  var rolando = null;

  window.addEventListener('scroll', function () {
    paginaRolando = true;
    clearTimeout(rolando);
    rolando = setTimeout(function () { paginaRolando = false; }, 400);
  }, { passive: true });

  function podeAbrirSozinha() {
    if (!noCelular()) return false;
    if (estado.tipo !== 'frete') return false;          /* so a meta interrompe */
    if (paginaRolando) return false;                    /* nunca embaixo do dedo */

    try {
      if (sessionStorage.getItem(CHAVE_VISTA)) return false;   /* uma vez por sessao */
      if (sessionStorage.getItem(CHAVE_RECUSA)) return false;  /* ela ja disse nao */
    } catch (e) {}

    return true;
  }

  function vigiarFimDaDescricao() {
    var fim = document.querySelector('.theoric-pdp__shipping-block') ||
              document.querySelector('.product__description');
    if (!fim || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        if (!podeAbrirSozinha()) return;

        setTimeout(function () {
          if (!podeAbrirSozinha()) return;
          try { sessionStorage.setItem(CHAVE_VISTA, '1'); } catch (e) {}
          abrir(false);
        }, 500);

        io.disconnect();
      });
    }, { threshold: 0.6 });

    io.observe(fim);
  }

  /* ---------------------------------------------------------- a partida */
  function iniciar(carrinho) {
    decidir(carrinho);
    pintarLinha();

    /* a folha aberta acompanha o carrinho SEM redesenhar os cards */
    if (folha.classList.contains('esta-aberta')) {
      if (!estado.tipo) fechar(false);
      else pintarFolha();
    }
  }

  corrigirSelo();

  if (window.TheoricCart) {
    TheoricCart.ao(iniciar);          /* pinta agora e a cada mudanca do carrinho */
    TheoricCart.sincronizar(true);
  } else {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(iniciar).catch(function () {});
  }

  window.addEventListener('resize', function () { pintarLinha(); medirBarra(); });
  medirBarra();
  vigiarFimDaDescricao();
})();
